module.exports = __webpack_public_path__ + "media/images/pic/teachers/agata-krukowska-828c41b32e4af122a3d434115c363a92.png";